module.exports = __webpack_public_path__ + "static/media/visa.b1684820.svg";